// Swipe + desktop open/zoom behavior for Shopify product media (Dawn-compatible)
// Mobile: fullscreen modal w/ swipe (your CSS handles fullscreen & fit).
// Desktop: click opens modal if possible; otherwise falls back to theme zoom;
// if neither exists, it synthesizes a dblclick to trigger any dblclick zoom.
// Also binds swipe/drag in modal and inline galleries.

(function () {
  const THRESHOLD = 40;   // minimum horizontal movement (px) to count as a swipe
  const MAX_ANGLE = 30;   // swipe must be mostly horizontal

  // ---- helpers --------------------------------------------------------------

  function getModal(el) {
    return el.closest('.product-media-modal, product-modal, dialog') || document;
  }

  function getTrack(modal) {
    return (
      modal.querySelector('.product-media-modal__content .slider') ||
      modal.querySelector('.product-media-modal__content [class*="slider"]') ||
      modal.querySelector('.product-media-modal__content .embla__container') ||
      modal.querySelector('.product-media-modal__content .keen-slider') ||
      modal.querySelector('.product-media-modal__content .splide__list') ||
      modal.querySelector('.product-media-modal__content .swiper-wrapper') ||
      null
    );
  }

  function getContent(modal) {
    return modal.querySelector('.product-media-modal__content') || null;
  }

  function clickButtons(modal, dir) {
    const nextBtn =
      modal.querySelector('button[name="next"], .slider-button.next, .slider-button--next, [data-action="next"]');
    const prevBtn =
      modal.querySelector('button[name="previous"], .slider-button.previous, .slider-button--prev, [data-action="previous"]');

    if (dir === 'next' && nextBtn) { nextBtn.click(); return true; }
    if (dir === 'prev' && prevBtn) { prevBtn.click(); return true; }
    return false;
  }

  function scrollByViewport(el, dir) {
    if (!el) return false;
    const vw = el.clientWidth || window.innerWidth;
    el.scrollTo({ left: el.scrollLeft + (dir === 'next' ? vw : -vw), behavior: 'smooth' });
    return true;
  }

  // ---- swipe binding --------------------------------------------------------

  function bindSwipe(container) {
    if (!container || container.__swipeBound) return;
    container.__swipeBound = true;

    let startX = 0, startY = 0, active = false;

    function onStart(e) {
      const t = (e.touches && e.touches[0]) || e;
      startX = t.clientX;
      startY = t.clientY;
      active = true;
    }

    function onMove(e) {
      if (!active) return;
      const t = (e.touches && e.touches[0]) || e;
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      const angle = Math.abs(Math.atan2(dy, dx) * 180 / Math.PI);
      // prevent vertical scroll when clearly swiping horizontally
      if (Math.abs(dx) > Math.abs(dy) && angle <= MAX_ANGLE) e.preventDefault();
    }

    function onEnd(e) {
      if (!active) return;
      active = false;

      const t = (e.changedTouches && e.changedTouches[0]) || e;
      const dx = t.clientX - startX;
      if (Math.abs(dx) < THRESHOLD) return;

      const dir = dx < 0 ? 'next' : 'prev';
      const modal = getModal(container);
      const track = getTrack(modal);
      const content = getContent(modal);

      // Prefer native controls, then fallback to track/content scroll
      if (clickButtons(modal, dir)) return;
      if (scrollByViewport(track, dir)) return;
      scrollByViewport(content, dir);
    }

    // Touch
    container.addEventListener('touchstart', onStart, { passive: true });
    container.addEventListener('touchmove', onMove, { passive: false });
    container.addEventListener('touchend', onEnd, { passive: true });

    // Optional desktop drag
    container.addEventListener('mousedown', onStart);
    container.addEventListener('mousemove', onMove);
    container.addEventListener('mouseup', onEnd);
  }

  function attachSwipeEverywhere() {
    // Modal content
    document.querySelectorAll('.product-media-modal__content').forEach(bindSwipe);

    // Common inline gallery containers in product page
    document
      .querySelectorAll('.product__media-wrapper, .product .media-gallery, .product .slider--product, .product__media-list')
      .forEach(bindSwipe);

    // Common slider tracks inside inline gallery
    document
      .querySelectorAll('.product__media-wrapper .slider, .product__media-list .slider, .product__media-wrapper .swiper-wrapper, .product__media-wrapper .splide__list')
      .forEach(bindSwipe);
  }

  // ---- desktop click behavior ----------------------------------------------

  // CSS.escape polyfill (older Safari)
  if (typeof CSS === 'undefined' || typeof CSS.escape !== 'function') {
    // eslint-disable-next-line no-undef
    window.CSS = window.CSS || {};
    CSS.escape = function (s) { return String(s).replace(/[^a-zA-Z0-9_\-]/g, '\\$&'); };
  }

  function findProduct(el) {
    return el.closest('.product, .product-section, .product-main, .shopify-section') || document.querySelector('.product');
  }

  function getActiveMedia(product) {
    return (
      product?.querySelector('.product__media-list .slider__slide[aria-hidden="false"]') ||
      product?.querySelector('.product__media-list .slider__slide:not([hidden])') ||
      product?.querySelector('.product__media-item--active, .is-active') ||
      product?.querySelector('.product__media, .product__media-item, .media')
    );
  }

  function findModalOpener(product) {
    if (!product) return null;
    const active = getActiveMedia(product);
    const mediaId =
      active?.dataset?.mediaId ||
      active?.getAttribute?.('data-media-id') ||
      (active?.id && active.id.replace(/^Slide-/, ''));

    if (mediaId) {
      const exact =
        product.querySelector(`.product__modal-opener[data-media-id="${CSS.escape(mediaId)}"]`) ||
        product.querySelector(`[data-media-id="${CSS.escape(mediaId)}"][data-open-media-modal]`);
      if (exact) return exact;
    }

    return (
      product.querySelector('.product__modal-opener') ||
      product.querySelector('[data-open-media-modal], [data-action="open-media"]')
    );
  }

  function findZoomControl(product) {
    if (!product) return null;
    return (
      product.querySelector('button[name="zoom"]') ||
      product.querySelector('.product__zoom-button, [data-action="zoom-in"]')
    );
  }

  function synthesizeDblClick(target) {
    const img = target.closest('img, .media, .product__media') || target;
    if (!img) return;
    const evt = new MouseEvent('dblclick', { bubbles: true, cancelable: true, view: window });
    img.dispatchEvent(evt);
  }

  // Only on desktop / hover-capable devices
  function enableDesktopMediaOpen() {
    if (!matchMedia('(hover: hover)').matches) return;

    // Use bubbling listener; only preventDefault when we take over
    document.addEventListener('click', function (e) {
      const mediaEl = e.target.closest(
        '.product__media, .product__media-item, .media img, .product__media-wrapper, .media'
      );
      if (!mediaEl) return;

      // Ignore controls (next/prev, thumbs, links, etc.)
      if (e.target.closest('button, a, .thumbnail-list, .slider-button, [data-thumbnails]')) return;

      const product = findProduct(mediaEl);
      const opener = findModalOpener(product);
      const zoomBtn = findZoomControl(product);

      if (opener) {
        e.preventDefault();
        e.stopPropagation();
        opener.click();          // open modal (your CSS keeps it contained on desktop)
        return;
      }

      if (zoomBtn) {
        e.preventDefault();
        e.stopPropagation();
        zoomBtn.click();         // fall back to theme inline zoom
        return;
      }

      // Last resort: try dblclick zoom without blocking the single-click
      synthesizeDblClick(mediaEl);
    });
  }

  // ---- init & observers -----------------------------------------------------

  const obs = new MutationObserver(attachSwipeEverywhere);
  obs.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () {
    attachSwipeEverywhere();
    enableDesktopMediaOpen();
  });

  window.addEventListener('load', attachSwipeEverywhere);
  window.addEventListener('shopify:section:load', attachSwipeEverywhere);
})();